/* eslint-disable max-lines */
/* eslint-disable sort-keys */

import {keyframes} from 'stitches/config'

const rotate = keyframes({
    '0%': {transform: 'rotate(0deg)'},
    '100%': {transform: 'rotate(360deg)'},
})()

const skeletonSlide = keyframes({
    '0%': {left: '-30px'},
    '66.67%': {left: '-30px'},
    '100%': {left: '100%'},
})()


export const heroWrapper = {
    background: '$embedHeroBackground',
    backgroundSize: '$embedHero',
    color: '$embedHero',
    borderWidth: '$embedHero',
    borderStyle: '$embedHero',
    borderColor: '$embedHeroBorder',
    padding: '$embedHero',
    borderBottomLeftRadius: '$embedHero',
    borderBottomRightRadius: '$embedHero',
    fontFamily: '$embedHero',
    fontSize: '$embedHero',
    fontWeight: '$embedHero',
    fontStyle: '$embedHero',
    fontVariant: '$embedHero',
    lineHeight: '$embedHero',
    variants: {
        type: {
            queue: {},
            chat: {},
            questionnaire: {},
            login: {},
        },
        hide: {
            true: {
                padding: 0,
                border: 'none',
            },
        },
        isVideoChannel: {true: {}},
        isClosed: {true: {}},
    },
    compoundVariants: [
        {
            isVideoChannel: true,
            isClosed: false,
            css: {'&&': {padding: '$embedHero'}},
        },
    ],
}

export const heroContent = {height: '100%'}

export const heroContentInQueue = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    variants: {reverseEmbedHeroContentOrdering: {true: {flexDirection: 'column-reverse'}}},
}

export const heroContentInChat = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
}

export const spinnerWrapper = {
    '> svg': {
        color: '$embedQueueSpinner',
        animation: `${rotate} 2s linear infinite`,
        overflow: 'unset',
        width: '100%',
        height: '100%',
    },
    'position': 'relative',
    '> span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    'width': '$embedQueueSpinner',
    'height': '$embedQueueSpinner',
    'margin': '10px 0',
}

export const title = {
    textAlign: 'center',
    fontFamily: '$embedHeroTitle',
    fontSize: '$embedHeroTitle',
    fontWeight: '$embedHeroTitle',
    fontStyle: '$embedHeroTitle',
    fontVariant: '$embedHeroTitle',
    color: '$embedHeroTitle',
    lineHeight: '$embedHeroTitle',
    margin: '$embedHeroTitle',
}

export const titleInQueue = {
    textAlign: 'center',
    fontFamily: '$embedHeroTitleInQueue',
    fontSize: '$embedHeroTitleInQueue',
    fontWeight: '$embedHeroTitleInQueue',
    fontStyle: '$embedHeroTitleInQueue',
    fontVariant: '$embedHeroTitleInQueue',
    color: '$embedHeroTitleInQueue',
    lineHeight: '$embedHeroTitleInQueue',
    margin: '$embedHeroTitleInQueue',
}

export const subtitle = {
    fontFamily: '$embedHeroSubtitle',
    fontSize: '$embedHeroSubtitle',
    fontWeight: '$embedHeroSubtitle',
    fontStyle: '$embedHeroSubtitle',
    fontVariant: '$embedHeroSubtitle',
    color: '$embedHeroSubtitle',
    lineHeight: '$embedHeroSubtitle',
    textAlign: 'center',
    margin: '$embedHeroSubtitle',
}

export const subtitleInQueue = {
    fontFamily: '$embedHeroSubtitleInQueue',
    fontSize: '$embedHeroSubtitleInQueue',
    fontWeight: '$embedHeroSubtitleInQueue',
    fontStyle: '$embedHeroSubtitleInQueue',
    fontVariant: '$embedHeroSubtitleInQueue',
    color: '$embedHeroSubtitleInQueue',
    lineHeight: '$embedHeroSubtitleInQueue',
    textAlign: 'center',
    margin: '$embedHeroSubtitleInQueue',
}

export const memberImages = {
    'display': 'flex',
    'justifyContent': 'center',
    'div[data-name="user-avatar"]': {
        'width': '$embedHeroAvatar',
        'height': '$embedHeroAvatar',
        '> div:first-child': {
            backgroundColor: '$embedHeroAvatarBackground',
            borderColor: '$embedHeroAvatarBorder',
            color: '$embedHeroAvatar',
            fontFamily: '$embedHeroAvatar',
            fontSize: '$embedHeroAvatar',
            fontWeight: '$embedHeroAvatar',
            fontStyle: '$embedHeroAvatar',
            fontVariant: '$embedHeroAvatar',
            lineHeight: '$embedHeroAvatar',
            minWidth: '$embedHeroAvatar',
            width: '$embedHeroAvatar',
            height: '$embedHeroAvatar',
        },
    },
    '> div': {
        'marginLeft': '-20px',
        '&:first-child': {marginLeft: 0},
    },
    'marginBottom': '10px',
}

export const channelAvatar = {
    'display': 'flex',
    'justifyContent': 'center',
    '> div': {
        backgroundColor: '$embedHeroAvatarBackground',
        borderColor: '$embedHeroAvatarBorder',
        color: '$embedHeroAvatar',
        fontFamily: '$embedHeroAvatar',
        fontSize: '$embedHeroAvatar',
        fontWeight: '$embedHeroAvatar',
        fontStyle: '$embedHeroAvatar',
        fontVariant: '$embedHeroAvatar',
        lineHeight: '$embedHeroAvatar',
        minWidth: '$embedHeroAvatar',
        width: '$embedHeroAvatar',
        height: '$embedHeroAvatar',
    },
    'marginBottom': '5px',
}

export const moreUsers = {
    borderWidth: '$avatar',
    borderStyle: 'solid',
    borderRadius: '$avatarMidBorder',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: '$embedHeroBackground',
    borderColor: '$embedHeroAvatarBorder',
    color: '$embedHeroAvatar',
    fontFamily: '$embedHeroAvatar',
    fontSize: '$embedHeroAvatar',
    fontWeight: '$embedHeroAvatar',
    fontStyle: '$embedHeroAvatar',
    fontVariant: '$embedHeroAvatar',
    lineHeight: '$embedHeroAvatar',
    minWidth: '$embedHeroAvatar',
    width: '$embedHeroAvatar',
    height: '$embedHeroAvatar',
}

export const videoMeetingWrapper = {
    marginTop: '20px',
    variants: {noMargin: {true: {marginTop: 0}}},
}

export const errorWrapper = {padding: '0 40px'}

export const errorTitle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'center',
    fontFamily: '$embedHeroErrorTitle',
    fontSize: '$embedHeroErrorTitle',
    fontWeight: '$embedHeroErrorTitle',
    fontStyle: '$embedHeroErrorTitle',
    fontVariant: '$embedHeroErrorTitle',
    color: '$embedHeroErrorTitle',
    lineHeight: '$embedHeroErrorTitle',
    margin: '$embedHeroErrorTitle',
}

export const errorMessage = {
    textAlign: 'center',
    fontFamily: '$embedHeroErrorMessage',
    fontSize: '$embedHeroErrorMessage',
    fontWeight: '$embedHeroErrorMessage',
    fontStyle: '$embedHeroErrorMessage',
    fontVariant: '$embedHeroErrorMessage',
    color: '$embedHeroErrorMessage',
    lineHeight: '$embedHeroErrorMessage',
    margin: '$embedHeroErrorMessage',
}

export const errorButtonWraper = {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
}

export const queuePosition = {
    color: '$embedQueuePosition',
    fontSize: '$embedQueuePosition',
}

export const skeletonLoader = {
    'backgroundColor': '$skeletonLoaderBackground',
    'color': '$skeletonLoader',
    'fontSize': '$skeletonLoader',
    'fontWeight': '$skeletonLoader',
    'padding': '10px 20px',
    'borderRadius': '12px',
    'position': 'relative',
    'margin': '20px 0 10px',
    'overflow': 'hidden',
    '> div': {
        position: 'relative',
        zIndex: 2,
    },
    '&::after': {
        background: '$skeletonLoaderProgress',
        animation: `${skeletonSlide} 1.5s linear infinite`,
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-30px',
        height: '100%',
        width: '30px',
        zIndex: 1,
    },
}
